<template>
<div class="sl-show-box" v-loading="loading">
  <sl-box :title="item.name" :cnt="item.number" :index="index" v-for="(item, index)  in data" :key="index"></sl-box>
</div>
</template>
<script>
import SlBox from './sl-box'
export default {
  name: 'sl-show-box',
  components: {
    SlBox
  },
  data() {
    return {
      loading: true
    }
  },
  props: {
    data: {
      type: Array,
      default: []
    }
  },
  watch: {
    data(item) {
      this.loading = item.length === 0 ? true : !true
    }
  }
}
</script>
<style scoped>
.sl-show-box {
  display: flex;
  flex-wrap: wrap;
  min-height: 110px;
  gap: 16px;
}

@media screen and (orientation:portrait) and (max-width: 1140px) {
  .sl-show-box {
    min-height: 236px;
  }
}

@media screen and (orientation:portrait) and (max-width: 768px) {
  .sl-show-box {
    min-height: 362px;
  }
}
</style>



// WEBPACK FOOTER //
// sl-show-box.vue?53272663